module.exports = __webpack_public_path__ + "static/img/1.0743c42.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/sp/1.png
// module id = lSmm
// module chunks = 0